
import { Link } from 'react-router-dom';

const AboutSection = () => {
  const features = [
    'خبرة تمتد لأكثر من 15 عاماً في مجال الأنظمة الأمنية',
    'فريق عمل محترف ومدرب على أعلى المستويات',
    'استخدام أحدث التقنيات والمعدات العالمية',
    'دعم فني متميز ومتابعة مستمرة بعد التركيب',
  ];

  return (
    <section className="py-24 bg-white">
      <div className="container mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Left Side - Image */}
          <div className="relative">
            <div className="rounded-3xl overflow-hidden shadow-2xl">
              <img
                src="https://public.readdy.ai/ai/img_res/4642e8862e3653b2d8aa916fbee5232a.jpg"
                alt="فريق العمل المحترف"
                className="w-full h-[500px] object-cover"
              />
            </div>

            {/* Floating Badge */}
            <div className="absolute -top-6 -right-6 bg-primary text-white px-8 py-6 rounded-2xl shadow-2xl">
              <div className="flex items-center gap-3">
                <i className="ri-award-fill text-4xl"></i>
                <div>
                  <div className="text-2xl font-bold">+15</div>
                  <div className="text-sm">عام خبرة</div>
                </div>
              </div>
            </div>

            {/* Floating Stats */}
            <div className="absolute -bottom-6 -left-6 bg-navy text-white px-8 py-6 rounded-2xl shadow-2xl">
              <div className="flex items-center gap-3">
                <i className="ri-building-line text-4xl text-primary"></i>
                <div>
                  <div className="text-2xl font-bold">+500</div>
                  <div className="text-sm text-silver">مشروع منجز</div>
                </div>
              </div>
            </div>
          </div>

          {/* Right Side - Content */}
          <div>
            {/* Badge */}
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-primary bg-primary/5 mb-6">
              <span className="text-sm font-semibold text-primary">من نحن</span>
            </div>

            {/* Heading */}
            <h2 className="text-4xl lg:text-5xl font-bold text-navy-light leading-tight mb-6">
              شريكك الموثوق في
              <br />
              <span className="text-primary">الحلول الأمنية المتقدمة</span>
            </h2>

            {/* Description */}
            <p className="text-gray-dark text-lg leading-relaxed mb-8">
              نحن شركة رائدة في مجال توفير الحلول الأمنية المتكاملة، نعمل على حماية المنشآت والمشاريع الكبرى بأحدث التقنيات العالمية. نفخر بخبرتنا الواسعة وفريق العمل المحترف الذي يضمن تقديم أفضل الخدمات بأعلى معايير الجودة والاحترافية.
            </p>

            {/* Features List */}
            <ul className="space-y-4 mb-10">
              {features.map((feature, index) => (
                <li key={index} className="flex items-start gap-3">
                  <div className="w-6 h-6 flex items-center justify-center rounded-full bg-primary/10 flex-shrink-0 mt-1">
                    <i className="ri-check-line text-primary text-sm"></i>
                  </div>
                  <span className="text-gray-dark text-base leading-relaxed">{feature}</span>
                </li>
              ))}
            </ul>

            {/* CTA Button */}
            <Link
              to="/about"
              className="inline-flex items-center gap-2 px-8 py-4 border-2 border-primary text-primary text-base font-semibold rounded-lg hover:bg-primary hover:text-white transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              <span>اكتشف المزيد</span>
              <i className="ri-arrow-left-line"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
